/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type FileUploadRequestMutationVariables = Types.Exact<{
  input: Types.FileUploadRequestInput;
}>;


export type FileUploadRequestMutation = { __typename: 'Mutation', fileUploadRequest: { __typename: 'FileUploadRequestPayload', assetUrl: string, uploadUrl: string } };


export const FileUploadRequestDocument = gql`
    mutation FileUploadRequest($input: FileUploadRequestInput!) {
  fileUploadRequest(input: $input) {
    assetUrl
    uploadUrl
  }
}
    `;
export type FileUploadRequestMutationFn = ApolloReactCommon.MutationFunction<FileUploadRequestMutation, FileUploadRequestMutationVariables>;

/**
 * __useFileUploadRequestMutation__
 *
 * To run a mutation, you first call `useFileUploadRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFileUploadRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fileUploadRequestMutation, { data, loading, error }] = useFileUploadRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFileUploadRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FileUploadRequestMutation, FileUploadRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FileUploadRequestMutation, FileUploadRequestMutationVariables>(FileUploadRequestDocument, options);
      }
export type FileUploadRequestMutationHookResult = ReturnType<typeof useFileUploadRequestMutation>;
export type FileUploadRequestMutationResult = ApolloReactCommon.MutationResult<FileUploadRequestMutation>;
export type FileUploadRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<FileUploadRequestMutation, FileUploadRequestMutationVariables>;